import {CommonModule} from '@angular/common';
import {NgModule} from '@angular/core';
import {FormsModule} from '@angular/forms';
import {MdCheckboxModule} from '@angular/material';
import {TermandconditionComponent} from './termandcondition.component';

@NgModule({
  imports: [CommonModule, FormsModule, MdCheckboxModule],
  declarations: [TermandconditionComponent],
  exports: [TermandconditionComponent],
})
export class TermandconditionModule {}



// WEBPACK FOOTER //
// ./src/app/shared/ui/termandcondition/termandcondition.module.ts